import { clone } from '../../../../common/common';

// ------------------------------------
// Constants
// ------------------------------------
export const SWITCH_TAB = 'SWITCH_TAB';
export const PRODUCTS_TAB = 0;
export const CUSTOM_TAB = 1;
export const READY_CATEGORIES_TAB = 2;

// ------------------------------------
// Actions
// ------------------------------------

export const switchTab = tab => {
  return { type: SWITCH_TAB, payload: { tab } };
};

// ------------------------------------
// Action Handlers
// ------------------------------------

const processSwitchTab = (state, action) => {
  return clone(state, { activeTab: action.payload.tab });
};

export const TABS_ACTION_HANDLERS = {
  [SWITCH_TAB]: processSwitchTab,
};



// WEBPACK FOOTER //
// ./app/javascript/design/routes/Moodboard/modules/tabs.js